import React from "react";
import { PageRendererProps, Link } from "gatsby";
import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "react-cookie-consent";

interface Props extends PageRendererProps {
  children: React.ReactNode;
}

const Layout = ({ location, children }: Props) => {
  return (
    <div className="leading-normal tracking-normal text-white gradient">
      <Header location={location} />

      {children}

      <Footer />

      <CookieConsent
        location="bottom"
        buttonText="Akzeptieren"
        cookieName="gatsby-gdpr-google-analytics"
        style={{ background: "#2d3748" }}
        buttonStyle={{
          padding: "8px 16px",
          boxShadow:
            "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
          borderRadius: "9999px",
          fontWeight: 700,
          color: "#2d3748",
          boxSizing: "border-box"
        }}
      >
        Durch die weitere Nutzung der Seite stimmst du der Verwendung von
        Cookies und den Datenschutzrichtlinien zu.{" "}
        <Link to="/privacy-policy" className="text-yellow-500">
          Weitere Informationen
        </Link>
      </CookieConsent>
    </div>
  );
};

export default Layout;
